import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { usePostalCodeContext } from '../../../contexts/PostalCodeProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import SetupCardBodyInfo from '../../CommonComps/Cards/SetupCardBodyInfo';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../../CommonComps/NoTableDataFound';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import AddPostalCodeAction from './AddPostalCodeAction';

const ShowAllPostalCodes = () => {
  // integration of context hooks here
  const {
    postalCodeList,
    setTargetedPostalCode,
    setShowDeleteModal,
    setShowViewModal,
    isError,
    isLoading,
    isSuccess,
  } = usePostalCodeContext();

  // integration of custom hooks here
  const { featureBasedPermissions } =
    useCheckUserFeaturePermissions('cityPostalCode');

  // rendering show all postal codes section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Postal Codes'
              additionalComponent={
                <AddPostalCodeAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
            >
              {postalCodeList.length ? (
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5 px-2'>
                  {postalCodeList.map((postalCode) => (
                    <SetupCard
                      key={postalCode.id}
                      title={postalCode.city_name}
                      label={postalCode.city_name}
                      viewBtnTitle='View Postal Code Details'
                      deleteBtnTitle='Delete Postal Codes'
                      showDeleteModalHandler={
                        featureBasedPermissions.includes('DELETE')
                          ? () => {
                              setTargetedPostalCode(postalCode);
                              setShowDeleteModal(true);
                            }
                          : undefined
                      }
                      showViewModalHandler={() => {
                        setTargetedPostalCode(postalCode);
                        setShowViewModal(true);
                      }}
                    >
                      <div className='border-t border-dashed border-legal-dark-blue pt-1'>
                        <SetupCardBodyInfo
                          label='Province'
                          info={postalCode.province_name}
                        />

                        <SetupCardBodyInfo
                          label='Postal Codes'
                          info={postalCode.postal_codes.slice(0, 4).join(', ')}
                          moreInfoCount={
                            postalCode.postal_codes.length > 4
                              ? postalCode.postal_codes.length - 4
                              : undefined
                          }
                        />
                      </div>
                    </SetupCard>
                  ))}
                </div>
              ) : (
                <NoTableDataFound message='No Postal Codes Found!!' />
              )}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load postal code Data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllPostalCodes;
